import { API_ORIGIN } from '../constants';

/**
 * Resolve an image path to a full URL.
 * Absolute URLs (http/https) are returned as-is.
 * Relative paths (e.g. /uploads/products/...) are prefixed with the API server origin.
 */
export const resolveImageUrl = (src: string): string => {
  if (!src) return '';
  if (src.startsWith('http://') || src.startsWith('https://') || src.startsWith('blob:')) {
    return src;
  }
  return `${API_ORIGIN}${src}`;
};
